module.exports = "/images/sorting.svg?0abd1d4b89b77f694448b0a0c6a62fd3";